import { Meta, TravelerInfo } from "@app/interfaces";
import { BookedTraveler } from "./booked-traveler.model";
export class BookedTravelerCollection {
  public _meta: Meta;
  private _collection: any[];

  constructor(bookedTravelerCollection?:TravelerInfo) {
    this._meta = {class: 'BookedTravelerCollection'};

    this._collection = [];
    if (bookedTravelerCollection?._collection) {
      for (let index = 0; index < bookedTravelerCollection._collection.length; index++) {
        let bookedTraveler = new BookedTraveler(bookedTravelerCollection._collection[index]);
        this.addBookedTraveler(bookedTraveler);
      }
    }
  }

  /**
   * Public
   * Adds a BookedTraveler
   */
  addBookedTraveler(bookedTraveler) {
     // check if the passenger is already added
    let matchingBookedTraveler = this.findBookedTraveler(bookedTraveler);
    if (matchingBookedTraveler == null) {
      this._collection.push(bookedTraveler);
    } else {
      matchingBookedTraveler.merge(bookedTraveler);
    }
  }

  /**
   * Finds the booked traveler for a passenger
   * @param passenger passenger to locate
   * @return BookedTraveler matching BookedTraveler by passenger id, or null if not found
   */
  findBookedTraveler(passenger) {
    return this.findBookedTravelerById(passenger.id);
  }

  findBookedTravelerById(id) {
    for (let index = 0; index < this._collection.length; index++) {
      let bookedTraveler = this._collection[index];
      if (bookedTraveler.id == id) {
        return bookedTraveler;
      }
    }
    return null;
  }

  clearPremiereUpgrade() {
    for (let index = 0; index < this._collection.length; index++) {
      let bookedTraveler = this._collection[index];
      bookedTraveler.clearPremiereUpgrade();
    }
  }

  clearSeats() {
    for (let index = 0; index < this._collection.length; index++) {
      let bookedTraveler = this._collection[index];
      bookedTraveler.clearSeats();
    }
  }

  validate() {
    return this._collection.length > 0;
  }

  clearEmpty() {
    for (let index = 0; index < this._collection.length; index++) {
      let bookedTraveler = this._collection[index];
      bookedTraveler.clearEmpty();
    }
  }

  getSeatBalance() {
    let total = 0;
    for (let index = 0; index < this._collection.length; index++) {
      let bookedTraveler = this._collection[index];
      total += bookedTraveler.getSeatBalance();
    }
    return total;
  }

  /**
   * Static method, assigned to class
   * Instance ('this') is not available in static context
   */
  buildWithReservation(reservation) {
    let collection = new BookedTravelerCollection(null);
    for (let index = 0; index < reservation.passengers.length; index++) {
      let passenger = reservation.passengers[index];
      let bookedTraveler = new BookedTraveler(passenger);
      collection.addBookedTraveler(bookedTraveler);
    }
    return collection;
  }

}
